var languageConfigs = {
  and: "and",
  retake: "Re-speak",
  tapToTalk: "Tap to talk about it",
  typeAnswer: "Type-in your answer",
  analyzeMyResponse: "Analyze my response",
  doneCheckIn: "Done conversation",
  done: "Done",
  viewResult: "View analysis result",
  viewEmotionBag: "View emotion bubble",
  close: "Close",
  nextStep: "Next step",
  listenToEmotion: "Calm me down",
  speakOutEmotion: "Start conversation",
  letsTalk: "Let's talk",
  letsStart: "Let's start",
  communitySharing: "Community emotion basing on",
  tryout: "Try-out InnerMe!",
  someoneShared: "Someone shared",
  youShared: "You shared",
  hi: "Hi",
  friend: "there",
  myNameIs: "My name is:",
  you: "you",
  yourRating: "Your rating:",
  feedback: "Your feedback:",
  next: "Next",
  youLook: "#replace{{0}} look",
  butLittleBit: "but a little",
  youLookLittleBit: "#replace{{0}} look a little bit",
  expressions: {
    angry: "angry",
    disgusted: "disgusted",
    fearful: "fearful",
    happy: "happy",
    neutral: "neutral",
    sad: "sad",
    surprised: "surprised"
  }
}
export default languageConfigs;
